document.addEventListener('DOMContentLoaded', function () {
  const dropdownContainers = document.querySelectorAll('.currency-dropdown');
  const rates = window.customCurrency?.rates || {};
  const currentLang = document.documentElement.lang || 'en';
  
  // function updatePrices1(currency) {
  //   console.log('updatePrices1')
  //   const rate = rates[currency]?.rate || 1;
  //   const label = (currentLang === 'ar' ? rates[currency]?.code_ar : rates[currency]?.name) || currency;

  //   document.querySelectorAll('.money').forEach(el => {
  //     console.log('money', el)
  //     const baseValue = parseFloat(el.getAttribute('data-base'));
  //     console.log('money baseValue', baseValue)
  //     if (!isNaN(baseValue)) {
  //       const value = baseValue * rate;
  //       console.log('money value', value)
  //       // const rounded = Math.round(value); // Apply rounding logic
  //       const rounded = parseFloat(value.toFixed(1));
  //       const formatted = rounded.toLocaleString(undefined, {
  //         minimumFractionDigits: 0,
  //         maximumFractionDigits: 1
  //       });
  //       el.textContent = `${formatted} ${label}`;
  //       console.log('money value', el.textContent)
  //     }
  //   });
    
  //   console.log('price updated');
  // }

  // window.updatePrices1 = updatePrices1; // 👈 expose it globally

  // Update prices for shadow
  function updatePrices(currency) {
    console.log('updatePrices')
  const rate = rates[currency]?.rate || 1;
  const label = (currentLang === 'ar' ? rates[currency]?.code_ar : rates[currency]?.name) || currency;

  function updateMoneyElements(root) {
    root.querySelectorAll('.money').forEach(el => {
      const baseValue = parseFloat(el.getAttribute('data-base'));

      if (!isNaN(baseValue)) {
        // console.log('baseValue',baseValue)
        const value = baseValue * rate;
        const rounded = parseFloat(value.toFixed(1));
        const formatted = rounded.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1
        });
        el.textContent = `${formatted} ${label}`;
      }
    });
  }

  // Update normal DOM
  updateMoneyElements(document);

  // Update known shadow roots (like Adoric)
  const adoric = document.querySelector('adoric-bundle-mark-six');
  if (adoric?.shadowRoot) {
    updateMoneyElements(adoric.shadowRoot);
  }

  // console.log('Prices updated in both DOM and shadow DOM');
}
  window.updatePrices = updatePrices; // 👈 expose it globally

  // Update prices for shadow


  
  function buildCurrencyList(optionsList) {
    optionsList.innerHTML = ''; // Clear existing options
    for (const code in rates) {
      const li = document.createElement('li');
      li.dataset.value = code;
      li.innerHTML = `<div class="fflag fflag-${rates[code].flag || ''} ff-wave">&nbsp;</div> ${(currentLang === 'ar' ? rates[code].name_ar : rates[code].name) || code}`;
      li.title = rates[code].name || code; // English name tooltip
      optionsList.appendChild(li);
    }
  }

  function setupDropdown(dropdownContainer) {
    const dropdown = dropdownContainer.querySelector('.currencySelected');
    const optionsList = dropdownContainer.querySelector('.currencyOptions');

    dropdown.addEventListener('click', () => {
      optionsList.style.display = optionsList.style.display === 'block' ? 'none' : 'block';
    });

    optionsList.addEventListener('click', (e) => {
      if (e.target.closest('li')) {
        const li = e.target.closest('li');
        const selectedCurrency = li.dataset.value;

        // Update all dropdowns with new selection
        dropdownContainers.forEach(container => {
          const d = container.querySelector('.currencySelected');
          d.innerHTML = li.innerHTML;
        });

        window.customCurrency.current = selectedCurrency;
        localStorage.setItem('currency', selectedCurrency);
        updatePrices(selectedCurrency);
        optionsList.style.display = 'none';
      }
    });

    // Close dropdown if clicked outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.currency-dropdown')) {
        optionsList.style.display = 'none';
      }
    });
  }

  function getCurrencyKeyByFlag(flagCode) {
  for (const [key, value] of Object.entries(rates)) {
    if (value.flag === flagCode) {
      return key; // e.g. returns 'BHD'
    }
  }
  return null; // if not found
}


  if (dropdownContainers.length > 0 && rates) {
    dropdownContainers.forEach(dropdownContainer => {
      const optionsList = dropdownContainer.querySelector('.currencyOptions');
      buildCurrencyList(optionsList);
      setupDropdown(dropdownContainer);
    });

   
   
    let saved = localStorage.getItem('currency');
    
     if (!localStorage.getItem('currency')){
      const userCountry = Shopify.country;
       const currency = getCurrencyKeyByFlag(userCountry);
       console.log('currency', currency);
       console.log('userCountry',userCountry)

       if (!currency){
         saved = 'AED';
       } else {
         saved = currency;
       }
     }
    
    if (saved && rates[saved]) {
      window.customCurrency.current = saved;
      updatePrices(saved);

      // Preselect currency in all dropdowns
        
      dropdownContainers.forEach(dropdownContainer => {
        const dropdown = dropdownContainer.querySelector('.currencySelected');
        const optionsList = dropdownContainer.querySelector('.currencyOptions');
        const li = optionsList.querySelector(`li[data-value="${saved}"]`);
        if (li) {
          dropdown.innerHTML = li.innerHTML;
        }
      });
    }
  }

  // Shopify event listener: reapply currency after cart updates
  document.addEventListener('cart:updated', function () {
    const current = window.customCurrency?.current;
    if (current) {
      console.log('cart:updated event detected — applying currency.');
      updatePrices(current);
    }
  });

  document.querySelector('#variantIdInput').addEventListener('change', function (event) {
    const current = window.customCurrency?.current;
    if (current) {
      console.log('Variant changed in product-form.', current);
      setTimeout(() => {
          updatePrices(current);
      }, 10);

    }
});

});

